"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLotteryRewards = void 0;
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var currencies_1 = require("../currencies");
var next_intl_1 = require("next-intl");
var useLotteryRewards = function (_a) {
    var lotteryId = _a.lotteryId;
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var lang = (0, next_intl_1.useLocale)();
    var _b = (0, useQuery_1.useQuery)({
        canRender: !!lotteryId,
        path: keys_1.GET_LOTTERY_REWARDS,
        revalidateOnMount: true,
        payload: {
            currency: currentCurrency,
            lang: lang,
            input: {
                filter: {
                    lotteryId: lotteryId,
                },
            },
        },
    }), data = _b.data, error = _b.error, isLoading = _b.isLoading, isValidating = _b.isValidating;
    return {
        data: data === null || data === void 0 ? void 0 : data.data,
        isLoading: isLoading,
        isValidating: isValidating,
        error: error,
    };
};
exports.useLotteryRewards = useLotteryRewards;
